(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jl-featured"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.jl-featured .jl-filter').forEach(function (bar) {
  var grid = bar.parentElement.querySelector('.jl-grid');
  bar.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jl-filter]');
    if (!btn) return;
    bar.querySelectorAll('.jl-filter__btn').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
    var mode = btn.getAttribute('data-jl-filter');
    grid.querySelectorAll('.jl-card').forEach(function (card) {
      card.hidden = (mode !== 'all' && card.getAttribute('data-orient') !== mode);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jl-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-jl-origin]');
  if (!root) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  root.classList.add('js-anim');
  var items = root.querySelectorAll('[data-r]');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  for (var i = 0; i < items.length; i++) io.observe(items[i]);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
